
import { ref, computed } from "vue";
import { useStore } from "vuex";
import { Actions } from "@/store/enums/StoreEnums";
export default {
  props: ["data"],
  setup(props, { emit }) {
    const supplier: any = ref(props.data);
    const store = useStore();
    store.dispatch(Actions.SUPPLIER_LIST);
    const supplierList = computed(
      () => store.state.SupplierModule.supplier.value || []
    );

    const onChange = (args) => {
      emit("changeSupplier", args);
    };
    return { close, supplier, store, supplierList, onChange };
  },
};
